<template>
    <div class="row">

      <div class="col-12 card">
        <h4>Отчёт по видам отходов Контрагента</h4>
        <br><small v-if="this.startDate && this.endDate">c {{ format_date(this.startDate, 'date') }} по {{ format_date(this.endDate, 'date') }}</small>
        <div class="row justify-content-space-between" v-if="PartnerWasteReports.answer">
          <div class="col-12 top-24">
            {{ PartnerWasteReports.answer }}
          </div>
        </div>
        <div class="row justify-content-space-between" v-else>

            <div class="col-12">
              <div class="top-24">
                <div class="row">
                  <div class="col-6">
                    <div class="text-field">
                      <label class="text-field__label">Дата начала</label>
                      <div class="text-field__icon">
                        <input
                          class="text-field__input"
                          type="date"
                          v-model="startDate"
                          @change="handleDateChange"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="text-field">
                      <label class="text-field__label">Дата окончания</label>
                      <div class="text-field__icon">
                        <input
                          class="text-field__input"
                          type="date"
                          v-model="endDate"
                          @change="handleDateChange"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="PartnerWasteReports">
                <PartnerWasteReportsList/>
              </div>
              <div class="row" v-else>
                Идёт загрузка...
              </div>
            </div>
        </div>
      </div>
    </div>
</template>
  
  <script>
    import PartnerWasteReportsList from "@/components/Ecology/PartnerWasteReports/PartnerWasteReportsList.vue";
    import { useRoute } from 'vue-router'
    import moment from 'moment'

    const route = useRoute()


    export default {
      components: { PartnerWasteReportsList },
      data() {
        return {
          title: "Отчёт по видам отходов",
          startDate: this.year_ago(),
          endDate: this.today_date(),
        }
      },
      computed: {
        currentUser() {
          return this.$store.state.auth.user;
        },
        PartnerWasteReports() {
          return this.$store.state.eco_partner_waste_reports
        },
      },
      methods: {
        year_ago(){
          const yearAgo = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000);

          return moment(String(yearAgo)).format('YYYY-MM-DD')
        },
        today_date(){
            const today = new Date();
            return moment(String(today)).format('YYYY-MM-DD')
        },
        handleDateChange() {
          if (this.startDate && this.endDate) {
            this.$store.dispatch("fetchEcologyPartnerWasteReports", {
              company_inn: this.$route.params.id,
              start_date: this.startDate,
              finish_date: this.endDate
            });
          }
        },
        format_date(value, time='NaN'){
          if (value) {
            if (time != 'NaN') {
              return moment(String(value)).format('DD.MM.YYYY')
            } else {
              return moment(String(value)).format('DD.MM.YYYY HH:mm')
            }
          }
        },
      },
      created() {
        this.$store.dispatch("fetchEcologyPartnerWasteReports", {
          company_inn: this.$route.params.id,
          start_date: this.startDate,
          finish_date: this.endDate
        });
      },
    };
  </script>
  